module.exports = __webpack_public_path__ + "img/icon_admin.2515c72c.svg";